/*jshint esversion: 6 */
/*jshint sub:true*/
// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';
import Vue from 'vue';

const initialState = () => ({
  messages_current_user: [],
  messages_projects: {},
  messages_projects_active: {},
  messages_businesses: {},
  messages_twork_packages: {},
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getMessagesCurrentUser: () => state.messages_current_user,
  getMessagesProject: () => () => {
    let messages = [];
    return messages;
  },
  getMessagesProjectWarningActive: () => () => {
    let messages = [];
    return messages;
  },
  getMessagesProjectNotificationActive: () => () => {
    let messages = [];
    return messages;
  },
  getMessagesBusiness: () => () => {
    let messages = [];
    return messages;
  },
  getMessagesTWorkPackage: () => () => {
    let messages = [];
    return messages;
  },
  getWP2: (state) => state.wp_2,
};
// Actions
const actions = {
  requestMessagesCurrentUser(){
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestMarkMessageAsRead(){
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestMessagesProject(){
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestMessagesProjectActive(){
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestMessagesBusiness(){
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestMessagesTWorkPackage(){
    return new Promise((resolve) => {
        resolve();
      });
  },
  requestSendMessage(){
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_messages_current_user(state, messages){
    Vue.set(state, 'messages_current_user', messages);
  },
  set_messages_twork_packages(state, payload){
    Vue.set(state.messages_twork_packages, payload.id, payload.messages);
  },
  set_messages_projects(state, payload){
    Vue.set(state.messages_projects, payload.id, payload.messages);
  },
  set_messages_projects_active(state, payload){
    Vue.set(state.messages_projects_active, payload.id, payload.messages);
  },
  set_messages_businesses(state, payload){
    Vue.set(state.messages_businesses, payload.id, payload.messages);
  },
  remove_current_user_message(state, payload){
    let index = state.messages_current_user.findIndex(msg => msg.id === payload.message_id);
    state.messages_current_user.splice(index, 1);
  },
  push_message_twork_packages(state, payload){
    if (! state.messages_twork_packages[payload.id]) {
      Vue.set(state.messages_twork_packages, payload.id, []);
    }
    state.messages_twork_packages[payload.id].push(payload.message);
  },
  push_message_projects(state, payload){
    if (! state.messages_projects[payload.id]) {
      Vue.set(state.messages_projects, payload.id, []);
    }
    state.messages_projects[payload.id].push(payload.message);
  },
  push_message_businesses(state, payload){
    if (! state.messages_businesses[payload.id]) {
      Vue.set(state.messages_businesses, payload.id, []);
    }
    state.messages_businesses[payload.id].push(payload.message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
